export default {
  thai_buddhist_holy_day: 'Thai Buddhist',
  chinese_buddhist_holy_day: 'Chinese Buddhist',
  chinese_god_worship_day: "God's Worship Day",
  auspicious_day: 'Auspicious/Inauspicious',
  thai_buddhist_holiday: 'Religious Day',
  // religious_holiday: 'Religious Day',
  // thai_buddhist_day: 'Thai Buddhist',
  thai_holiday: 'Holiday',
  // holiday: 'Holiday',
  compatibility: 'Compatibility',
  feature: 'Feature',
  purchases: 'Purchases',
  general: 'General',
  auspicious: 'Auspicious',
  // subscription: 'Subscription',
  // auspicious_day_and_inauspicious_day: 'Auspicious/Inauspicious',

  // thai_buddhist_day: 'Thai Buddhist',
  // chinese_day: 'Chinese Buddhist',
  // auspicious_day_and_inauspicious_day: 'Auspicious/Inauspicious',
  // feature: 'Feature',
  // holiday: 'Holiday',
  // religious_holiday: 'Religious Day',
  // god_worship_holiday: "God's Worship Day",
  // general: 'General',
  // date_selection_service: 'Date Selection',
  // compatibility: 'Compatibility',
  // subscription: 'Subscription',
}

export const newPreference = {
  thai_buddhist_holy_day: 'Thai Buddhist',
  chinese_buddhist_holy_day: 'Chinese Buddhist',
  chinese_god_worship_day: "God's Worship Day",
  auspicious_day: 'Auspicious/Inauspicious',
  thai_buddhist_holiday: 'Religious Day',
  religious_holiday: 'Religious Day',
  thai_buddhist_day: 'Thai Buddhist',
  thai_holiday: 'Holiday',
  holiday: 'Holiday',
  compatibility: 'Compatibility',
  feature: 'Feature',
  purchases: 'Subscription',
  general: 'General',
  auspicious: 'Auspicious',
  subscription: 'Subscription',
  auspicious_day_and_inauspicious_day: 'Auspicious/Inauspicious',
}

export const newNotiHistoryFilter = {
  thai_buddhist_day: 'Thai Buddhist',
  chinese_day: 'Chinese Buddhist',
  auspicious_day_and_inauspicious_day: 'Auspicious/Inauspicious',
  feature: 'Feature',
  holiday: 'Holiday',
  religious_holiday: 'Religious Day',
  god_worship_holiday: "God's Worship Day",
  general: 'General',
  date_selection_service: 'Date Selection',
  compatibility: 'Compatibility',
  subscription: 'Subscription',
}
